import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import renderHTML from 'react-render-html';
import { useNavigate } from "react-router-dom";
import { format, parseISO } from 'date-fns';
import { Apiurl } from "../Configuration/configuration";


function TickerTape() {
    const [show, setShow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    const [dataWatch, setDataWatch] = useState([]);

    const [data, setData] = useState(false);
    const { BaseLiveURL } = useContext(URLstateContext);
    const [nodatafound, setnodatafound] = useState(false);

    const [loadingshow, setloadingshow] = useState(false);
    let getDataWatch, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;



    useEffect(() => {
        postData(`${Apiurl}/api/Login/AdminTickerTape`)
            .then((data) => {

                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }




    return (
        <>
        {(data != null) ? 
            <Container fluid className="AttentionBG">
                <Container>
                    <Row>
                        <Col md={12} lg={12} xl={12}>

                            <marquee scrolldelay="200" className="AttentionheadingAdmin" behavior="scroll" direction="left" onmouseover="this.stop()" onmouseout="this.start()">
                            {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                {data &&
                                    data.map(
                                        ({ tickertape }) => (
                                            <div className="marqueeDiv">
                                                <span> {renderHTML(tickertape)}</span>
                                            </div>
                                        )
                                    )}
                            </marquee>
                        </Col>
                    </Row>
                </Container>
            </Container> :''}
        </>
    )


}

export default TickerTape